import { PublicClientApplication, type Configuration } from '@azure/msal-browser';
import { CONFIG } from '../config';

const msalConfig: Configuration = {
  auth: {
    clientId: CONFIG.CLIENT_ID,
    authority: `https://login.microsoftonline.com/${CONFIG.TENANT_ID}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const API_LOGIN_REQUEST = {
  scopes: [CONFIG.API_SCOPE],
};
